import { FileRepository } from 'application/repositories/FileRepository';
import {
    FileEntity,
    FileFireInsuranceResult,
    FileInfoEntiy,
    FilePaymentResult,
} from 'domain/entities/FileEntity';
import axiosConfig from 'infrastructure/config/axios';

export class FileAPI implements FileRepository {
    async uploadFile(data: FileEntity): Promise<any> {
        const formData = new FormData();
        const obj: any = data;
        for (const property in obj) {
            if (obj[`${property}`] instanceof Array) {
                obj[`${property}`].forEach((item: any) => {
                    formData.append(`${property}[]`, item);
                });
            } else {
                formData.append(property, obj[`${property}`]);
            }
        }
        const API_URL = '/mypage/upload-debt-document';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, formData);
        return response.data;
    }
    async getFiles(settlementId: number): Promise<FileInfoEntiy> {
        const API_URL = `/mypage/debt-document/${settlementId}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getFileInsurances(settlementId: number): Promise<FileFireInsuranceResult> {
        const API_URL = `/setting/file-insurance/${settlementId}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
    async uploadFileInsurance(data: FileEntity): Promise<any> {
        const formData = new FormData();
        const obj: any = data;
        for (const property in obj) {
            if (obj[`${property}`] instanceof Array) {
                obj[`${property}`].forEach((item: any) => {
                    formData.append(`${property}[]`, item);
                });
            } else {
                formData.append(property, obj[`${property}`]);
            }
        }
        const API_URL = '/setting/upload-file-insurance';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, formData);
        return response.data;
    }
    async getFilePayment(params: {
        settlementId: number;
        scheduleAdjustmentDiv: number;
    }): Promise<FilePaymentResult> {
        const API_URL = `/setting/file-payment`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }
    async confirmPayment(payload: { dealId: number; scheduleAdjustmentDiv: number }): Promise<any> {
        const API_URL = `/setting/confirm-payment`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL, payload);
        return response.data;
    }
}
